import "../App.css"
import React from 'react'
import { useState, useEffect } from 'react';
import ShoppingCarts from "./ShoppingCarts";
import { ShoppingBagIcon } from '@heroicons/react/24/outline'


function Header({num}){

    const [estado, setEstado] = useState(false)

    const toggleEstado = () =>{
        setEstado(!estado);
    }


    const inicio=()=>{
        window.location.href = '/';
    }
    return (
        <>
            <header className="header-other">

                <ShoppingCarts isOpen={estado}/>

                <main className='flex justify-between mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8'>

                    <h2 onClick={()=> inicio()} className='text-4xl font-bold tracking-tight text-[#fb8cff] cursor-pointer'>
                        S
                        <sub className='text-4xl font-bold tracking-tight'>B</sub>
                    </h2>

                    <a onClick={()=>toggleEstado()} class="relative cursor-pointer inline-flex items-center p-3 text-sm font-medium text-center text-white focus:outline-none">
                        <ShoppingBagIcon
                        className="h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                        aria-hidden="true"
                        />
                        <div class="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full -top-2 -right-2">{num}</div>
                    </a>
                    
                </main>   

            </header>

            <br/><br/><br/>
        </>
    )
}

export default Header
